export { default as AlternateName } from './AlternateName';
export { default as POA } from './POA';
export { default as PersonalInfo } from './PersonalInfo';
export { default as Address } from './Address';
export { default as CreditReporting } from './CreditReporting';
export { default as CustomFields } from './CustomFields';
export { default as Declarations } from './Declarations';
